<!-- 应用使用学校占比 -->
<template>
  <div class="school-use-app">
    <!-- <div class="school-use-app-line"></div> -->
    <div class="school-use-app-title">
      <div class="name">各应用使用学校占比</div>
      <!-- <div class="more">详情<i class="el-icon-arrow-right"></i></div> -->
    </div>
    <div class="school-use-app-list">
      <div class="school-use-app-li" v-for="item in rankList" :key="item.id">
        <div class="school-use-app-li-name">{{ item.name }}</div>
        <div class="school-use-app-li-progress">
          <el-progress :percentage="item.progress" :stroke-width="14" :show-text="false"></el-progress>
        </div>
        <div class="school-use-app-li-number">{{ item.progress }}%</div>
      </div>
    </div>
  </div>
</template>

<script>
import {getPlatformAppUseSchoolStatAPI} from "@/service/api.js"
export default {
  name: 'school-use-app',
  components: {
  },
  props:{
    //区域id
    regionId:{
      type:String,
      default:""
    },
    regionType:{
      type:String,
      default:''
    },
    //省id
    provinceId:{
      type:String,
      default:''
    },
    //市id
    cityId:{
      type:String,
      default:''
    },
    //区id
    districtId:{
      type:String,
      default:''
    },
    //乡镇地址
    address:{
      type:String,
      default:''
    },
    //开始时间
    startTime:{
      type:String,
      default:""
    },
    //结束时间
    endTime:{
      type:String,
      default:""
    },
    
  },
  data() {
      return {
        rankList:[] 
    }
  },
  watch:{
    startTime(){
      this.getPlatformAppUseSchoolStat();
    },
    endTime(){
      this.getPlatformAppUseSchoolStat();
    },
    address(){
      this.getPlatformAppUseSchoolStat();
    },
  },
  methods: {
    /**
     * @name 获取平台各应用使用学校数
     */
    getPlatformAppUseSchoolStat(){
      let params={
        regionId:this.regionId,
        startTime:this.startTime?`${this.startTime} 00:00:00` :'',
        endTime:this.endTime ? `${this.endTime} 23:59:59` :'',
        provinceId:this.provinceId,
        cityId:this.cityId,
        districtId:this.districtId,
        address:this.address,
        regionType:this.regionType
      }
      getPlatformAppUseSchoolStatAPI(params).then((res)=>{
        let allUse = res.hdpxUseSchNum + res.jtbkUseSchNum + res.msgzsUseSchNum + res.rsUseSchNum + res.tpkUseSchNum + res.zxdyUseSchNum + res.zxfdUseSchNum + res.zxkcUseSchNum
        this.rankList = [];
        this.rankList.push({
          name:"资源中心",
          number:res.rsUseSchNum,
          progress:Number((res.rsUseSchNum/allUse*100).toFixed(2)) || 0,
          id:1
        })
        this.rankList.push({
          name:"听评课",
          number:res.tpkUseSchNum,
          progress:Number((res.tpkUseSchNum/allUse*100).toFixed(2)) || 0,
          id:2
        })
        this.rankList.push({
          name:"集体备课",
          number:res.jtbkUseSchNum,
          progress:Number((res.jtbkUseSchNum/allUse*100).toFixed(2)) || 0,
          id:3
        })
        this.rankList.push({
          name:"活动评选",
          number:res.hdpxUseSchNum,
          progress:Number((res.hdpxUseSchNum/allUse*100).toFixed(2)) || 0,
          id:4
        })
        this.rankList.push({
          name:"在线课程",
          number:res.zxkcUseSchNum,
          progress:Number((res.zxkcUseSchNum/allUse*100).toFixed(2)) || 0,
          id:5
        })
        this.rankList.push({
          name:"在线答疑",
          number:res.zxdyUseSchNum,
          progress:Number((res.zxdyUseSchNum/allUse*100).toFixed(2)) || 0,
          id:6
        })
        this.rankList.push({
          name:"在线辅导",
          number:res.zxfdUseSchNum,
          progress:Number((res.zxfdUseSchNum/allUse*100).toFixed(2)) || 0,
          id:7
        })
        this.rankList.push({
          name:"名师工作室",
          number:res.msgzsUseSchNum,
          progress:Number((res.msgzsUseSchNum/allUse*100).toFixed(2)) || 0,
          id:8
        })
        this.rankList.sort((a,b)=>{
          return b.progress - a.progress
        })
      }).catch((err)=>{})
    }
  },
  mounted(){
    //获取平台各应用使用学校数
    this.getPlatformAppUseSchoolStat();
  },
}
</script>

<style lang="scss" scoped>
.school-use-app{
  width:100%;
  height:auto;
  margin-top:20px;
  position: relative;
  .school-use-app-line{
    width: 100%;
    height: 2px;
    background: linear-gradient(to right, #209CFF, transparent);
    background-color: rgba(0, 0, 0, 0);
    margin-bottom: 5px;
  }
  .school-use-app-title{
    background: url("~@/assets/images/qxdataboard/head-bg.png") no-repeat ;
    background-size:100% 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 40px;
    padding: 0 13px 0 18px;
    .name{
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #FFFFFF;
    }
    .more{
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #B9E3F7;
    }
  }
  .school-use-app-list{
    width: 100%;
    // height: 200px;
    overflow-y: hidden;
    margin-top: 10px;
    padding-left: 10px;
    padding-right: 10px;
    .school-use-app-li{
      display: flex;
      align-items: center;
      padding: 10px 0;
      .school-use-app-li-name{
        width: 80px;
        // text-align: left;
        // color: #fff;
        text-align: left;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #5B90E6;
      }
      .school-use-app-li-progress{
        width: 250px;
        text-align: left;
      }
      .school-use-app-li-number{
        margin-left: 20px;
        // color: #fff;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #5B90E6;
      }
    }
  }
}
</style>
<style lang="scss">
.school-use-app{
  .school-use-app-list{
    .school-use-app-li{
      .school-use-app-li-progress{
        .el-progress{
          .el-progress-bar{
            .el-progress-bar__outer{
              border-radius: 2px;
              .el-progress-bar__inner{
                border-radius: 2px;
                background: linear-gradient(90deg, #209CFF 0%, #68E0CF 100%);
              }
            }
          }
        }
      }
    }
  }
}
</style>